import React from 'react';
import { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import { FaSort, FaSortUp, FaSortDown, FaCalendarAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import useUserStore from '../store';
import axios from 'axios';
import { useAuth0 } from '@auth0/auth0-react';
import { FaCheck, FaTimes, FaEdit, FaSpinner } from 'react-icons/fa';
import { FaChartLine, FaTachometerAlt, FaUsers, FaDollarSign } from 'react-icons/fa';
import logo from '../Images/logo.png'
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css'
import IntroJs from 'intro.js';
import { useSwipeable } from 'react-swipeable';
import { FaDownload, FaInfoCircle, FaTrash, FaThumbsDown, FaThumbsUp, FaFilter } from 'react-icons/fa';
import moment from 'moment';
import { loadStripe } from '@stripe/stripe-js';
import { AiOutlineUnlock } from 'react-icons/ai';
import { FaRocket, FaStar, FaArrowUp, FaPlusCircle } from 'react-icons/fa';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FiXCircle, FiFileText, FiSlash } from 'react-icons/fi';

const stripePromise = loadStripe(`${process.env.REACT_APP_STRIPE_PROMISE}`);  // Replace with your actual publishable key

const ArticleListView = () => {
const {
userId,
setUserId,
blogs,
setBlogs,
drafts,
setDrafts,
keywordData,
setKeywordData,
loading,
setLoading,
error,
setError,
subscriptionEndDate, // Get subscriptionEndDate from store
setSubscriptionEndDate, // Get setSubscriptionEndDate from store
hasFetchedDrafts, // ADD THIS
setHasFetchedDrafts, // ADD THIS
} = useUserStore();
const [sortConfig, setSortConfig] = useState({ key: 'date', direction: 'ascending' });
const navigate = useNavigate();
const { user, isAuthenticated } = useAuth0();
const [processingTasks, setProcessingTasks] = useState({});
const [showFeedbackModal, setShowFeedbackModal] = useState(false);
const [feedbackText, setFeedbackText] = useState('');
const [currentArticleId, setCurrentArticleId] = useState(null);
const [hasSeenTutorial, setHasSeenTutorial] = useState(null); // Changed initial state to null
const [tutorialStarted, setTutorialStarted] = useState(false);
const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
const [isPaid, setIsPaid] = useState(false); // Store payment status
const [isExpanded, setIsExpanded] = useState(false);

// const [subscriptionEndDate, setSubscriptionEndDate] = useState(null); // Removed local state
const [loadingUpgrade, setLoadingUpgrade] = useState(false); // New loading state
const [dateRange, setDateRange] = useState([null, null]);
const [startDate, endDate] = dateRange;
const [currentArticleIndex, setCurrentArticleIndex] = useState(0);
const cardRef = useRef(null);
const [selectedStatus, setSelectedStatus] = useState('');
const [selectedType, setSelectedType] = useState('');
const [selectedDate, setSelectedDate] = useState('');
const [isFilterOpen, setIsFilterOpen] = useState(false);
const [statusDropdownOpen, setStatusDropdownOpen] = useState(false);
const [typeDropdownOpen, setTypeDropdownOpen] = useState(false);
const statusRef = useRef(null);
const typeRef = useRef(null);
const statusDropdownRef = useRef(null);
const typeDropdownRef = useRef(null);
const [expandedArticle, setExpandedArticle] = useState(null); // State for tracking expanded article
const [selectedDateRange, setSelectedDateRange] = useState([null, null]);
// const [isHowItWorksModalOpen, setIsHowItWorksModalOpen] = useState(false); // Removed
const [showSubscriptionExpiredModal, setShowSubscriptionExpiredModal] = useState(false); // New state for subscription expired modal
// Inside your component function:
const [showTooltip, setShowTooltip] = useState(false);
const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
const [isWelcomeModalOpen, setIsWelcomeModalOpen] = useState(false); // New state for welcome modal
const [currentPage, setCurrentPage] = useState(0); // New state for welcome modal page
// **NEW STATE - startTutorial**
const [startTutorial, setStartTutorial] = useState(false);


const welcomeModalPages = [
    {
        title: "🎉 Welcome to Trendhopper! (1/4)",
        content: (
            <>
                <p className="mb-2">
                    Your first article is in progress and will be ready in less than 5 minutes.
                </p>
                <p className="mb-4">
                    While you wait, <strong>optimize your blog settings:</strong>
                </p>
                <ul className="list-disc pl-5 mb-4">
                    <li><strong>Check your blog URL, description, and keywords</strong> to make sure they’re accurate.</li>
                    <li><strong>Ensure they’re relevant</strong> for better content generation.</li>
                </ul>
                <p>
                    Head to the <a href="/settings" className="text-blue-500 underline">Settings page</a> now to update them.
                </p>
            </>
        ),
    },
    {
        title: "🔄 How Trendhopper Works (2/4)",
        content: (
            <ol className="list-decimal pl-5 mb-4">
                <li><strong>Articles start as "Incomplete":</strong> This is a pitch. Reject it if you don’t like the title or direction. <em>Double-check your keywords and description first!</em></li>
                <li><strong>If you like the idea:</strong> Accept the draft, and Trendhopper will start writing the full article.</li>
            </ol>
        ),
    },
    {
        title: "🔄 How Trendhopper Works (3/4)",
        content: (
            <ol className="list-decimal pl-5 mb-4">
                <li><strong>"In Progress" status:</strong> Once the article is ready, review and refine it with our editor.</li>
                <li><strong>Automatic publishing:</strong> If you set up an integration, your article will be published when marked as "Complete."</li>
            </ol>
        ),
    },
    {
        title: "⚡ Tips & Questions (4/4)",
        content: (
            <>
                <h3 className="font-bold mb-2">⚡ Updating Your Keywords or Blog Description?</h3>
                <ul className="list-disc pl-5 mb-4">
                    <li>Reject any incomplete drafts if you change your keywords or description. This helps generate more relevant content.</li>
                </ul>
                <p className="mb-4">
                    💡 Have questions or requests? Contact us via the Feedback button in the <a href="/contact" className="text-blue-500 underline">sidebar</a>!
                </p>
            </>
        ),
    },
];

// const openHowItWorksModal = () => { // Removed
//     setIsHowItWorksModalOpen(true);
// };

// const closeHowItWorksModal = () => { // Removed
//     setIsHowItWorksModalOpen(false);
// };

const openWelcomeModal = () => {
    setIsWelcomeModalOpen(true);
    setCurrentPage(0); // Reset to the first page when opening
};

const closeWelcomeModal = async () => {
    setIsWelcomeModalOpen(false);
    setCurrentPage(0); // Reset page when closing
    if (!hasSeenTutorial) {
        try {
            if (userId) {
                console.log('Marking tutorial as seen for user:', userId);
                await axios.post(
                    `https://trendhopper-c3934b7293e6.herokuapp.com/mark-table-tutorial-seen/${user.email}/`,
                    { table_tutorial_seen: true }
                );
                setHasSeenTutorial(true);
            }
        } catch (err) {
            console.error('Error marking tutorial as seen:', err);
        }
        // set has seen tutorial
    }
};

const nextPage = () => {
    if (currentPage < welcomeModalPages.length - 1) {
        setCurrentPage(currentPage + 1);
    }
};

const prevPage = () => {
    if (currentPage > 0) {
        setCurrentPage(currentPage - 1);
    }
};


const saveTasksToCache = (tasks) => {
    localStorage.setItem('processingTasks', JSON.stringify(tasks));
};

const loadTasksFromCache = () => {
    const cachedTasks = localStorage.getItem('processingTasks');
    return cachedTasks ? JSON.parse(cachedTasks) : {};
};

const handleDateChange = (dates) => {
    setDateRange(dates);
};

const handleUpgradeClick = async () => {
    setLoadingUpgrade(true);
    setError(null);

    try {
        // Call the Django backend to create a checkout session
        const response = await axios.post(
            'https://trendhopper-c3934b7293e6.herokuapp.com/create-checkout-session/',
            { email: user.email }, // Send the email in the request body
            { headers: { 'Content-Type': 'application/json' } }
        );

        const session = response.data;

        if (session && session.id) {
            const stripe = await stripePromise;

            // Redirect to Stripe Checkout
            const { error } = await stripe.redirectToCheckout({
                sessionId: session.id,
            });

            if (error) {
                console.error('Error redirecting to checkout:', error);
                setError('Failed to redirect to checkout.');
            }
        } else {
            setError('Failed to create Stripe checkout session.');
        }
    } catch (err) {
        // Improved error handling (as in previous response)
        if (err.response && err.response.data && err.response.data.error) {
            setError(`Server Error: ${err.response.data.error}`);
            console.error('Error during upgrade:', err.response.data.error);
        } else if (err.request) {
            setError('No response received from server.');
            console.error('Error during upgrade: No response from server', err.request);
        } else {
            setError('Failed to initiate upgrade process.');
            console.error('Error during upgrade:', err);
        }
    } finally {
        setLoadingUpgrade(false);
    }
};

useEffect(() => {
    const fetchUserId = async () => {
        const cachedUserId = localStorage.getItem('userId');
        const userResponse = await axios.get(`https://trendhopper-c3934b7293e6.herokuapp.com/get-user/${user.email}/`);
        // Determine payment status based on stripe_customer_id
        if (userResponse.data.stripe_customer_id) {
            console.log('they are paid')
            setIsPaid(true); // User is paid
        } else {
            setIsPaid(false); // User is not paid
        }
        // Fetch subscriptionEndDate only if it's not already in the store or if it's outdated
        if (!subscriptionEndDate || moment().isAfter(moment(subscriptionEndDate))) { // **Refetch if no date or expired**
            if (userResponse.data.subscription_end_date) {
                setSubscriptionEndDate(userResponse.data.subscription_end_date); // Store the date in Zustand
            } else {
                setSubscriptionEndDate(null); // Ensure null if no date from backend
            }
        }

        if (subscriptionEndDate) {
            const endDate = moment(subscriptionEndDate); // Use moment to parse from store
            const now = moment();
            if (now.isAfter(endDate)) { // Compare dates
                console.log("end date: ", endDate)
                console.log("now = ", now)
                setIsPaid(false); // Subscription has expired
                setShowSubscriptionExpiredModal(true); // Show the expired subscription modal
            } else {
                setShowSubscriptionExpiredModal(false); // Ensure modal is closed if subscription is active
            }
        } else {
            setShowSubscriptionExpiredModal(false); // Ensure modal is closed if no end date
        }


        setHasSeenTutorial(userResponse.data.table_tutorial_seen);
        if (cachedUserId) {
            console.log('Using cached user ID:', cachedUserId);
            setUserId(cachedUserId);
            return;
        }

        if (!userId && isAuthenticated && user?.email) {
            try {
                console.log('Fetching user ID from backend', user.email);
                const response = await axios.get(`https://trendhopper-c3934b7293e6.herokuapp.com/users/exist/${user.email}/`);
                const fetchedUserId = response.data.user_id;
                console.log('fetchedUserId', fetchedUserId);
                localStorage.setItem('userId', fetchedUserId);
                setUserId(fetchedUserId);


            } catch (err) {
                console.error('Failed to fetch user ID:', err);
                setError('Failed to fetch user ID');
            }
        }
    };

    fetchUserId(); // **Call fetchUserId on component mount to ensure refetch**
}, [userId, isAuthenticated, user, setUserId, setError, setSubscriptionEndDate]); // Removed subscriptionEndDate from dependency array as we want to refetch on mount


const mapStatus = (status) => {
    switch (status) {
        case 0:
            return "Incomplete";
        case 1:
            return "Progress";
        case 2:
            return "Done";
        default:
            return "Unknown";
    }
};


useEffect(() => {
    const handleResize = () => {
        setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
}, []);


// **OPEN WELCOME MODAL ON MOUNT IF !hasSeenTutorial**
useEffect(() => {
    if (hasSeenTutorial === false) { // Modified condition to check for false explicitly
        openWelcomeModal();
    }
}, [hasSeenTutorial]);


// **START TUTORIAL AFTER WELCOME MODAL CLOSES AND DOM IS READY**
useEffect(() => {
    if (startTutorial && !tutorialStarted) { // **Condition: startTutorial is true AND tutorial not started**
        const observer = new MutationObserver(() => {
            const titleHeader = document.querySelector('#column-title');
            const statusHeader = document.querySelector('#column-status');

            if (titleHeader && statusHeader) {
                observer.disconnect();
                const intro = IntroJs();

                intro.setOptions({
                    steps: [
                        {
                            element: '#column-title',
                            intro: 'This column shows the titles of your articles.',
                        },
                        {
                            element: '#column-status',
                            intro: 'The status column indicates whether an article is Incomplete, In Progress, or Done, so you can track its progress at any time.',
                        },
                        {
                            element: '#column-date',
                            intro: 'View the scheduled completion date for each article, helping you stay on top of your deadlines.',
                        },
                        {
                            element: '#column-type',
                            intro: 'This column shows the article type (e.g., How-to, Versus, Educational Essay), giving you a quick overview of content categories.',
                        },
                        {
                            element: '#column-actions',
                            intro: 'Use this column to approve, reject, edit, or download the HTML for an article with just a few clicks.',
                        },

                    ],
                    showStepNumbers: false,
                    exitOnOverlayClick: true,
                    nextLabel: 'Next',
                    prevLabel: 'Back',
                    skipLabel: 'X',
                    doneLabel: 'Done',
                });

                const markTutorialAsSeen = async () => {
                    try {
                        if (userId) {
                            console.log('Marking tutorial as seen for user:', userId);
                            await axios.post(
                                `https://trendhopper-c3934b7293e6.herokuapp.com/mark-table-tutorial-seen/${user.email}/`,
                                { table_tutorial_seen: true }
                            );
                            setHasSeenTutorial(true);
                        }
                    } catch (err) {
                        console.error('Error marking tutorial as seen:', err);
                    }
                };
                intro.oncomplete(markTutorialAsSeen);
                intro.onskip(markTutorialAsSeen);

                intro.start();
                setTutorialStarted(true);
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });

        return () => observer.disconnect();
    }
}, [startTutorial, tutorialStarted, userId, user, setError]); // **Dependency on startTutorial**


const getStatusClasses = (status) => {
    switch (status) {
        case 'Done':
            return 'px-3 py-1 border border-white rounded bg-green-500/20 text-green-500 font-bold text-xs sm:text-sm';
        case 'Progress':
            return 'px-3 py-1 border border-white rounded bg-amber-500/20 text-amber-500 font-bold text-xs sm:text-sm';
        case 'Incomplete':
            return 'px-3 py-1 border border-white rounded bg-red-400/20 text-red-400 font-bold text-xs sm:text-sm';
        default:
            return 'px-3 py-1 border border-white rounded bg-gray-500/20 text-gray-500 font-bold text-xs sm:text-sm';
    }
};


useEffect(() => {
    const fetchBlogsAndDrafts = async () => {
        if (!userId) {
            setError("User ID is not available. Please log in.");
            return;
        }

        if (hasFetchedDrafts) { // ADD THIS CHECK
            console.log("Drafts already fetched, skipping refetch.");
            return; // Skip fetching if already fetched
        }

        setLoading(true);
        setError(null);

        try {
            console.log('the user id is', userId);
            const blogResponse = await fetch(`https://trendhopper-c3934b7293e6.herokuapp.com/user/${userId}/blogs/`);
            if (!blogResponse.ok) throw new Error('Failed to fetch blogs');
            const blogData = await blogResponse.json();
            setBlogs(blogData.blogs);

            const draftData = {};
            for (const blog of blogData.blogs) {
                const draftResponse = await fetch(`https://trendhopper-c3934b7293e6.herokuapp.com/drafts/${blog.id}/`);
                if (draftResponse.ok) {
                    const draftResponseData = await draftResponse.json();
                    // Add blogId to each draft here
                    draftData[blog.id] = draftResponseData.drafts.filter(draft => draft.status !== -1).map(draft => ({ ...draft, blogId: blog.id }));
                }
            }
            console.log('draftData', draftData);
            setDrafts(draftData);
            setHasFetchedDrafts(true); // SET FLAG AFTER FETCHING
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    fetchBlogsAndDrafts();
}, [userId, setBlogs, setDrafts, setLoading, setError, hasFetchedDrafts, setHasFetchedDrafts]); // Add hasFetchedDrafts and setHasFetchedDrafts to dependency array


useEffect(() => {
    const fetchKeywordsForDrafts = async () => {
        if (Object.keys(drafts).length === 0) return;

        const allKeywords = {};
        for (const blogId in drafts) {
            for (const draft of drafts[blogId]) {
                try {
                    const response = await axios.get(`https://trendhopper-c3934b7293e6.herokuapp.com/draft/${draft.id}/keywords`);
                    allKeywords[draft.id] = response.data.keywords;
                } catch (err) {
                    console.error(`Failed to fetch keywords for draft ${draft.id}:`, err);
                    allKeywords[draft.id] = [];
                }
            }
        }
        setKeywordData(allKeywords);
    };

    fetchKeywordsForDrafts();
}, [drafts, setKeywordData]);

useEffect(() => {
    const cachedTasks = loadTasksFromCache();
    const now = Date.now();
    const validTasks = {};

    for (const draftId in cachedTasks) {
        const task = cachedTasks[draftId];
        if (task && task.timestamp && (now - task.timestamp) <= 15 * 60 * 1000) {
            validTasks[draftId] = task;
        }
    }

    Object.keys(validTasks).forEach(draftId => {
        const task = validTasks[draftId];
        if (task && task.taskId) {
            const messages = task.action === 'accept'
                ? ['Researching Reddit...', 'Creating Outline...', 'Drafting Content...', 'Finalizing Article...']
                : ['Analyzing Pitch...', 'Identifying Issues...', 'Preparing New Draft...', 'Finalizing Pitch...'];
            startPolling(draftId, task.taskId, task.action, messages, task.messageIndex || 0);
        }
    });
    setProcessingTasks(validTasks);
}, []);

const clearExpiredTasks = () => {
    const cachedTasks = loadTasksFromCache();
    const now = Date.now();
    let hasChanges = false;
    const validTasks = {};

    for (const draftId in cachedTasks) {
        const task = cachedTasks[draftId];
        if (task && task.timestamp && (now - task.timestamp) <= 15 * 60 * 1000) {
            validTasks[draftId] = task;
        } else {
            hasChanges = true;
        }
    }

    if (hasChanges) {
        saveTasksToCache(validTasks);
        setProcessingTasks(validTasks);
    }
};

useEffect(() => {
    const intervalId = setInterval(clearExpiredTasks, 60 * 1000);

    return () => clearInterval(intervalId);
}, []);


// MODIFIED fetchDrafts
const fetchDrafts = useCallback(async () => {
    if (!userId) {
        setError("User ID is not available. Please log in.");
        return;
    }

    setError(null);

    try {
        const draftData = {};
        // You need to fetch blogs again to ensure you have the latest blog list.
        const blogResponse = await fetch(`https://trendhopper-c3934b7293e6.herokuapp.com/user/${userId}/blogs/`);
        if (!blogResponse.ok) throw new Error('Failed to fetch blogs');
        const blogData = await blogResponse.json();
        setBlogs(blogData.blogs); // Update blogs

        for (const blog of blogData.blogs) { // Iterate over the *fetched* blogs
            const draftResponse = await fetch(`https://trendhopper-c3934b7293e6.herokuapp.com/drafts/${blog.id}/`);
            if (draftResponse.ok) {
                const draftResponseData = await draftResponse.json();
                // Crucial: Add blogId to each draft here.  This is what was missing.
                draftData[blog.id] = draftResponseData.drafts.map(draft => ({ ...draft, blogId: blog.id }));
            }
        }
        setDrafts(draftData); // Set the drafts with the correct blogId.
    } catch (err) {
        setError(err.message);
    }
}, [userId, setDrafts, setError, setBlogs]); // Include setBlogs in dependencies


const sortedArticles = useMemo(() => {
    let articles = Object.values(drafts).flat().map(draft => ({
        ...draft,
        blog: blogs.find(blog => blog.id === draft.blogId),
        date: new Date(draft.date),
    }));


    articles = articles.map(article => ({ ...article, date: article.date.getTime() }));

    let sortableArticles = [...articles];
    if (sortConfig.key !== null) {
        sortableArticles.sort((a, b) => {
            if (a[sortConfig.key] < b[sortConfig.key]) {
                return sortConfig.direction === 'ascending' ? -1 : 1;
            }
            if (a[sortConfig.key] > b[sortConfig.key]) {
                return sortConfig.direction === 'ascending' ? 1 : -1;
            }
            return 0;
        });
    }
    return sortableArticles;
}, [blogs, drafts, sortConfig]);

const requestSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
        direction = 'descending';
    }
    setSortConfig({ key, direction });
};

const getSortIcon = (columnName) => {
    if (sortConfig.key === columnName) {
        return sortConfig.direction === 'ascending' ? <FaSortUp /> : <FaSortDown />;
    }
    return <FaSort />;
};

const getStatusColor = (status) => {
    switch (status) {
        case 'Done':
            return 'bg-green-500/20 text-green-500';
        case 'Progress':
            return 'bg-amber-500/20 text-amber-500';
        case 'Review':
            return 'bg-blue-500/20 text-blue-500';
        case 'Incomplete':
            return 'bg-red-400/20 text-red-400';
        default:
            return 'bg-gray-500/20 text-gray-500';
    }
};

const handleTitleClick = (articleId) => {
    if (articleId) {
        navigate(`/article/${articleId}`);
    }
};

const handleOpenFeedbackModal = (articleId) => {
    setCurrentArticleId(articleId);
    setShowFeedbackModal(true);
};

const handleCloseFeedbackModal = () => {
    setShowFeedbackModal(false);
    setFeedbackText('');
    setCurrentArticleId(null);
};

const handleFeedbackChange = (e) => {
    setFeedbackText(e.target.value);
};

const handleDownloadArticle = (article) => {
    try {
        const blob = new Blob([article.html], { type: 'text/html' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `article_${article.id}.html`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    } catch (error) {
        console.error('Error downloading article:', error);
        setError(`Failed to download article ${article.id}.`);
    }
};


const handleRejectWithFeedback = async () => {
    if (!currentArticleId) return;

    const url = `https://trendhopper-c3934b7293e6.herokuapp.com/reject-draft/${currentArticleId}/`;

    const messages = ['Analyzing Pitch...', 'Identifying Issues...', 'Preparing New Draft...', 'Finalizing Pitch...'];

    setProcessingTasks(prevTasks => {
        const newTasks = {
            ...prevTasks,
            [currentArticleId]: { status: 'pending', message: messages[0], timestamp: Date.now() }
        };
        saveTasksToCache(newTasks);
        return newTasks;
    });

    handleCloseFeedbackModal();

    try {
        const response = await axios.post(url, { feedback: feedbackText });
        const { task_id } = response.data;

        setProcessingTasks(prevTasks => {
            const newTasks = {
                ...prevTasks,
                [currentArticleId]: { status: 'pending', message: messages[0], taskId: task_id, action: 'reject', messageIndex: 0, timestamp: Date.now() }
            };
            saveTasksToCache(newTasks);
            return newTasks;
        });

        startPolling(currentArticleId, task_id, 'reject', messages, 0);

    } catch (err) {
        console.error("Error processing task:", err);
        setError(`Error processing article ${currentArticleId}. Please try again.`);
        setProcessingTasks(prevTasks => {
            const { [currentArticleId]: taskToRemove, ...rest } = prevTasks;
            saveTasksToCache(rest);
            return rest;
        });
    }
};

const filteredArticles = useMemo(() => {
    return sortedArticles.filter((article) => {
        // Added this check: If blog is undefined, filter out the article.
        if (!article.blog) {
            return false;
        }

        const matchesStatus =
            selectedStatus === '' || article.status === parseInt(selectedStatus, 10);
        const matchesType =
            selectedType === '' || article.type.trim() === selectedType.trim();

        const articleDate = new Date(article.date);

        const matchesDateRange =
            (!startDate || articleDate >= startDate) &&
            (!endDate || articleDate <= endDate);

        return matchesStatus && matchesType && matchesDateRange;
    });
}, [sortedArticles, selectedStatus, selectedType, startDate, endDate]);




const handleAcceptReject = async (articleId, action) => {
    const isAccept = action === 'accept';
    const messages = isAccept
        ? ['Researching Reddit...', 'Creating Outline...', 'Drafting Content...', 'Finalizing Article...']
        : ['Analyzing Pitch...', 'Identifying Issues...', 'Preparing New Draft...', 'Finalizing Pitch...'];
    const url = isAccept
        ? `https://trendhopper-c3934b7293e6.herokuapp.com/accept-draft/${articleId}/`
        : `https://trendhopper-c3934b7293e6.herokuapp.com/reject-draft/${articleId}/`;

    setProcessingTasks(prevTasks => {
        const newTasks = {
            ...prevTasks,
            [articleId]: { status: 'pending', message: messages[0], timestamp: Date.now() }
        };
        saveTasksToCache(newTasks);
        return newTasks;
    });

    try {
        const response = await axios.get(url);
        const { task_id } = response.data;

        setProcessingTasks(prevTasks => {
            const newTasks = {
                ...prevTasks,
                [articleId]: { status: 'pending', message: messages[0], taskId: task_id, action: action, messageIndex: 0, timestamp: Date.now() }
            };
            saveTasksToCache(newTasks);
            return newTasks;
        });

        startPolling(articleId, task_id, action, messages, 0);

    } catch (err) {
        console.error('Error processing task:', err);
        setError(`Error processing article ${articleId}. Please try again.`);

        setProcessingTasks(prevTasks => {
            const { [articleId]: removed, ...rest } = prevTasks;
            saveTasksToCache(rest);
            return rest;
        });
    }
};

const startPolling = async (draftId, taskId, action, messages, initialMessageIndex = 0) => {
    let taskStatus = 'PENDING';
    let step = initialMessageIndex;

    const intervalId = setInterval(() => {
        step = (step + 1) % messages.length;
        setProcessingTasks(prevTasks => {
            const newTasks = {
                ...prevTasks,
                [draftId]: { status: 'pending', message: messages[step], taskId: taskId, action: action, messageIndex: step, timestamp: Date.now() }
            };
            return newTasks;
        });
    }, 25000);

    while (taskStatus === 'PENDING') {
        try {
            const statusResponse = await axios.get(`https://trendhopper-c3934b7293e6.herokuapp.com/app/check-task-status/${taskId}`);
            taskStatus = statusResponse.data.status;
            if (taskStatus !== 'PENDING') break;
            await new Promise(resolve => setTimeout(resolve, 5000));
        } catch (error) {
            console.error("Error checking task status:", error);
            clearInterval(intervalId);
            setProcessingTasks(prevTasks => {
                const { [draftId]: removed, ...rest } = prevTasks;
                return rest;
            });
            const cachedTasks = loadTasksFromCache();
            const { [draftId]: taskToRemove, ...updatedTasks } = cachedTasks;
            saveTasksToCache(updatedTasks);
            return;
        }
    }

    clearInterval(intervalId);

    if (userId) {
        await fetchDrafts();  // Call the updated fetchDrafts
    }
    setProcessingTasks(prevTasks => {
        const { [draftId]: removed, ...rest } = prevTasks;
        return rest;
    });
    const cachedTasks = loadTasksFromCache();
    const { [draftId]: taskToRemove, ...updatedTasks } = cachedTasks;
    saveTasksToCache(updatedTasks);
};

const calculateAggregatedMetrics = (draftId) => {
    const keywords = keywordData[draftId] || [];

    if (keywords.length === 0) return {
        totalSearchVolume: 'N/A',
        avgDifficulty: 'N/A',
        competitionLevels: 'N/A',
        avgCpc: 'N/A',
    }

    const validKeywords = keywords.filter(keyword => keyword);

    const totalSearchVolume = validKeywords.reduce((sum, keyword) => sum + (keyword.search_volume_msv || 0), 0);
    const totalDifficulty = validKeywords.reduce((sum, keyword) => sum + (keyword.keyword_difficulty || 0), 0);
    const validDifficulties = validKeywords.filter(keyword => keyword.keyword_difficulty !== null)
    const avgDifficulty = validDifficulties.length > 0 ? Math.round(totalDifficulty / validDifficulties.length) : "N/A";


    const uniqueCompetitionLevels = [...new Set(validKeywords.map(keyword => keyword.competition).filter(Boolean))];
    const competitionLevels = uniqueCompetitionLevels.length > 0 ? uniqueCompetitionLevels.join(', ') : 'N/A';

    const totalCpc = validKeywords.reduce((sum, keyword) => sum + (parseFloat(keyword.cpc) || 0), 0);
    const validCpcs = validKeywords.filter(keyword => keyword.cpc !== null);
    const avgCpc = validCpcs.length > 0 ? (totalCpc / validCpcs.length).toFixed(2) : "N/A";


    return {
        totalSearchVolume,
        avgDifficulty,
        competitionLevels,
        avgCpc,
    };
};

const renderKeywordTooltip = (draftId) => {
    const keywords = keywordData[draftId] || [];
    if (!keywords || keywords.length === 0) {
        return <div className="text-gray-400">No keywords data available.</div>;
    }

    return (
        <div className="text-left p-3 bg-gray-700 shadow-lg">
            {keywords.map((keyword, index) => (
                <div
                    key={index}
                    className="mb-2 border-b border-gray-600 last:border-b-0 pb-2 last:mb-0 last:pb-0"
                >
                    <p className="font-bold text-white">{keyword.keyword}</p>
                    <p className="flex items-center gap-2">
                        <FaChartLine className="text-blue-400" />
                        Search Volume: <span className="text-gray-300">{keyword.search_volume_msv || 'N/A'}</span>
                    </p>
                    <p className="flex items-center gap-2">
                        <FaTachometerAlt className="text-purple-400" />
                        Difficulty: <span className="text-gray-300">{keyword.keyword_difficulty || 'N/A'}</span>
                    </p>
                    <p className="flex items-center gap-2">
                        <FaUsers className="text-green-400" />
                        Competition: <span className="text-gray-300">{keyword.competition || 'N/A'}</span>
                    </p>
                    <p className="flex items-center gap-2">
                        <FaDollarSign className="text-orange-400" />
                        CPC: <span className="text-gray-300">{keyword.cpc || 'N/A'}</span>
                    </p>
                </div>
            ))}
        </div>
    );
};
const renderKeywordAvailabilityIcon = (draftId, status) => {
    const keywords = keywordData[draftId] || [];
    const isDataAvailable = keywords.length > 0;

    return (
        <div className="flex items-center gap-2">
            {isDataAvailable ? (
                <FaCheck className="text-green-500" />
            ) : (
                <FaTimes className="text-red-500" />
            )}
            <span className="text-gray-400">{isDataAvailable ? 'Metrics Available' : 'No Metrics Available'}</span>
        </div>
    );
};
const renderKeywordMetrics = (draftId) => {
    const keywords = keywordData[draftId] || [];
    const isDataAvailable = keywords.length > 0; // Check if keywords data is available

    return (
        <div className="mt-4">
            <div className="flex items-center gap-2 mb-4">
                {isDataAvailable ? (
                    <FaCheck className="text-green-500" />
                ) : (
                    <FaTimes className="text-red-500" />
                )}
                <span className="text-gray-400">{isDataAvailable ? 'Metrics Available' : 'No Metrics Available'}</span>
            </div>

            {isDataAvailable ? (
                keywords.map((keyword, index) => (
                    <div key={index} className="mb-4 border-b border-gray-600 last:border-b-0 pb-2 last:mb-0 last:pb-0">
                        <p className="font-bold text-white">{keyword.keyword}</p>
                        <p className="flex items-center gap-2">
                            <FaChartLine className="text-blue-400" />
                            Search Volume: <span className="text-gray-300">{keyword.search_volume_msv || 'N/A'}</span>
                        </p>
                        <p className="flex items-center gap-2">
                            <FaTachometerAlt className="text-purple-400" />
                            Difficulty: <span className="text-gray-300">{keyword.keyword_difficulty || 'N/A'}</span>
                        </p>
                        <p className="flex items-center gap-2">
                            <FaUsers className="text-green-400" />
                            Competition: <span className="text-gray-300">{keyword.competition || 'N/A'}</span>
                        </p>
                        <p className="flex items-center gap-2">
                            <FaDollarSign className="text-orange-400" />
                            CPC: <span className="text-gray-300">{keyword.cpc || 'N/A'}</span>
                        </p>
                    </div>
                ))
            ) : (
                ''// Placeholder text when no data is available
            )}
        </div>
    );
};

const handlePredefinedFeedback = (text) => {
  setFeedbackText(text);  // Update the feedbackText state with the predefined text
};

const handleNextArticle = () => {
    if (currentArticleIndex < filteredArticles.length - 1) {
        setCurrentArticleIndex(currentArticleIndex + 1);
    }
};

const handlePreviousArticle = () => {
    if (currentArticleIndex > 0) {
        setCurrentArticleIndex(currentArticleIndex - 1);
    }
};
// Add this function with your other functions:

const swipeHandlers = useSwipeable({
    onSwipedLeft: () => handleNextArticle(),
    onSwipedRight: () => handlePreviousArticle(),
    preventDefaultTouchmoveEvent: true,
    trackMouse: true
});

const toggleFilter = () => {
    setIsFilterOpen(!isFilterOpen);
};

const toggleStatusDropdown = () => {
    setStatusDropdownOpen(!statusDropdownOpen);
    setTypeDropdownOpen(false);
};

const toggleTypeDropdown = () => {
    setTypeDropdownOpen(!typeDropdownOpen);
    setStatusDropdownOpen(false);
};

const closeAllDropdowns = () => {
    setStatusDropdownOpen(false);
    setTypeDropdownOpen(false);
};

useEffect(() => {
    const handleClickOutside = (event) => {
        if (
            statusDropdownOpen &&
            statusRef.current &&
            !statusRef.current.contains(event.target) &&
            statusDropdownRef.current &&
            !statusDropdownRef.current.contains(event.target)
        ) {
            setStatusDropdownOpen(false);
        }
        if (
            typeDropdownOpen &&
            typeRef.current &&
            !typeRef.current.contains(event.target) &&
            typeDropdownRef.current &&
            !typeDropdownRef.current.contains(event.target)
        ) {
            setTypeDropdownOpen(false);
        }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
        document.removeEventListener('mousedown', handleClickOutside);
    };
}, [statusDropdownOpen, typeDropdownOpen]);

useEffect(() => {
    setHasFetchedDrafts(false);
}, [userId, setHasFetchedDrafts]);

if (loading) {
    return (
        <div className="full-page-spinner flex flex-col items-center justify-center min-h-screen bg-gray-900">
            <div className="relative w-24 h-24">
                <img
                    src={logo}
                    alt="Trendhopper Logo"
                    className="absolute inset-0 m-auto w-12 h-12"
                />
                <div className="w-full h-full border-4 border-t-purple-500 border-r-transparent border-b-gray-600 border-l-gray-600 rounded-full animate-spin"></div>
            </div>
            <p className="text-white mt-4 text-center">Loading Trendhopper...</p>
        </div>
    );
}

if (error) {
    return <div>Error: {error}</div>;
}

const currentArticle = filteredArticles[currentArticleIndex];

return (
    <div className={`min-h-screen text-white ${isMobile ? 'pt-6' : ''}`}>
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-3xl font-bold flex items-center gap-2">
              Articles
              {!isMobile && (
                  <button
                      onClick={openWelcomeModal} // Changed to openWelcomeModal
                      className="flex items-center gap-2 px-3 py-1 text-sm bg-gray-700 text-white rounded hover:bg-gray-600 transition-all"
                  >
                      <FaInfoCircle />
                      How It Works {/* Changed text to How It Works, but opens Welcome Modal */}
                  </button>
              )}
          </h1>

            {isMobile ? (
                <button
                    onClick={toggleFilter}
                    className="p-2 rounded hover:bg-gray-700 transition-all flex items-center gap-2"
                >
                    <FaFilter className="text-white" />
                    <span className="text-white font-bold">Filters</span>
                </button>
            ) : (
              <div className="flex gap-2">
     {/* Upgrade or Pro Button */}
              <button
            onClick={isPaid ? '' : handleUpgradeClick}
            className={`px-4 py-2 font-semibold rounded-md
              ${isPaid
                ? 'bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 hover:bg-gradient-to-br text-white' // Pro styles
                : 'bg-gradient-to-r from-purple-400 via-purple-500 to-purple-600 hover:bg-gradient-to-br text-white' // Upgrade Now purple gradient styles
              }`}
          >
            {isPaid
              ? <><FaStar className="inline mr-1" /> Pro</>
              : <><FaPlusCircle className="inline mr-1" /> Upgrade Now</>
            }
          </button>

              {/* Incomplete Button */}
              {/* <button
                data-tooltip-id="incomplete-tooltip"
                data-tooltip-content="Incomplete: This article hasn't been started yet. You can accept or reject the idea."
                className="hidden sm:flex items-center justify-center px-3 py-1 border border-white rounded bg-red-400/20 text-red-400 font-bold text-xs sm:text-sm"
              >
                Incomplete
              </button>
              <Tooltip id="incomplete-tooltip" place="top" effect="solid" /> */}
            </div>
                )}
            </div>

        {isMobile ? (
            <div className="flex flex-col items-center justify-center" {...swipeHandlers}>
                {isFilterOpen && (
                    <div className="bg-gray-800 rounded-lg shadow-lg p-4 w-full max-w-md mb-4">
                        <div className="relative mb-2" ref={statusRef}>
                            <button
                                onClick={toggleStatusDropdown}
                                className="px-4 py-2 border border-gray-700 rounded-lg bg-gray-800 text-white focus:outline-none focus:ring-1 focus:ring-gray-600 focus:border-gray-600 transition-all w-full text-left flex items-center justify-between"
                            >
                                {selectedStatus === '' ? 'All Statuses' : mapStatus(parseInt(selectedStatus, 10))}
                                <FaSort className="text-gray-400" />
                            </button>
                            {statusDropdownOpen && (
                                <div
                                    ref={statusDropdownRef}
                                    className="absolute left-0 mt-1 w-full bg-gray-700 rounded-md shadow-lg z-10"
                                >
                                    <button
                                        onClick={() => { setSelectedStatus(''); closeAllDropdowns() }}
                                        className="block px-4 py-2 text-white hover:bg-gray-600 w-full text-left"
                                    >
                                        All Statuses
                                    </button>
                                    <button
                                        onClick={() => { setSelectedStatus('0'); closeAllDropdowns() }}
                                        className="block px-4 py-2 text-white hover:bg-gray-600 w-full text-left"
                                    >
                                        Incomplete
                                    </button>
                                    <button
                                            onClick={() => { setSelectedStatus('1'); closeAllDropdowns() }}
                                            className="block px-4 py-2 text-white hover:bg-gray-600 w-full text-left"
                                        >
                                            Progress
                                        </button>
                                        <button
                                            onClick={() => { setSelectedStatus('2'); closeAllDropdowns() }}
                                            className="block px-4 py-2 text-white hover:bg-gray-600 w-full text-left"
                                        >
                                            Done
                                        </button>
                                    </div>
                                )}
                            </div>
                            <div className="relative mb-2" ref={typeRef}>
                                <button
                                    onClick={toggleTypeDropdown}
                                    className="px-4 py-2 border border-gray-700 rounded-lg bg-gray-800 text-white focus:outline-none focus:ring-1 focus:ring-gray-600 focus:border-gray-600 transition-all w-full text-left flex items-center justify-between"
                                >
                                    {selectedType === '' ? 'All Types' : selectedType}
                                    <FaSort className="text-gray-400" />
                                </button>
                                {typeDropdownOpen && (
                                    <div
                                        ref={typeDropdownRef}
                                        className="absolute left-0 mt-1 w-full bg-gray-700 rounded-md shadow-lg z-10"
                                    >
                                        <button
                                            onClick={() => { setSelectedType(''); closeAllDropdowns() }}
                                            className="block px-4 py-2 text-white hover:bg-gray-600 w-full text-left"
                                        >
                                            All Types
                                        </button>
                                        {Array.from(new Set(sortedArticles.map((article) => article.type.trim()))).map((type) => (
                                            <button
                                                key={type}
                                                onClick={() => { setSelectedType(type); closeAllDropdowns() }}
                                                className="block px-4 py-2 text-white hover:bg-gray-600 w-full text-left"
                                            >
                                                {type}
                                            </button>
                                        ))}
                                    </div>
                                )}
                            </div>
                            <div className="relative">
                                    <DatePicker
                                        selectsRange
                                        startDate={startDate}
                                        endDate={endDate}
                                        onChange={handleDateChange}
                                        isClearable
                                        placeholderText="Select Date Range"
                                        className="w-full pr-4 py-2 border border-gray-700 rounded-lg bg-gray-800 text-white focus:outline-none focus:ring-1 focus:ring-gray-600 focus:border-gray-600 transition-all"
                                    />
                                    </div>
                        </div>
                    )}
                    {filteredArticles.length > 0 ? (
                        <div ref={cardRef} className="bg-gray-800 rounded-lg shadow-lg p-6 w-full max-w-md">
                            {currentArticle && (
                                <div className="flex flex-col max-h-[450px] overflow-y-auto relative">
                                    <h2
                                        className={`text-xl font-bold mb-2 ${currentArticle.status !== 0 ? 'cursor-pointer hover:underline' : 'cursor-not-allowed'}`}
                                        onClick={() => {
                                            if (currentArticle.status !== 0) {
                                                handleTitleClick(currentArticle.id);
                                            }
                                        }}
                                    >
                                        {currentArticle.title}
                                    </h2>
                                    <p className="text-gray-400 mb-4">{currentArticle.pitch}</p>

                                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 sm:gap-4 mb-4">
                                        <div className="flex items-center gap-2">
                                            <span className="text-sm sm:text-base text-gray-400 font-semibold">Date:</span>
                                            <span className="text-sm sm:text-base text-white">{new Date(currentArticle.date).toLocaleDateString()}</span>
                                        </div>

                                        <div className="flex items-center gap-2">
                                            <span className="text-sm sm:text-base text-gray-400 font-semibold">Status:</span>
                                            <span
                                                className={`inline-flex items-center justify-center px-3 py-1 rounded-full font-bold text-xs sm:text-sm
                                                ${currentArticle.status === 1 ? "bg-amber-500/20 text-amber-500"
                                                    : currentArticle.status === 2 ? "bg-green-500/20 text-green-500"
                                                    : currentArticle.status === 0 ? "bg-red-400/20 text-red-400"
                                                    : "bg-gray-500/20 text-gray-500"}`}
                                            >
                                                {currentArticle.status === 1 ? "Progress"
                                                    : currentArticle.status === 2 ? "Done"
                                                    : currentArticle.status === 0 ? "Incomplete"
                                                    : "Unknown"}
                                            </span>
                                        </div>

                                        <div className="flex items-center gap-2">
                                            <span className="text-sm sm:text-base text-gray-400 font-semibold">Type:</span>
                                            <span className="text-sm sm:text-base text-white">{currentArticle.type}</span>
                                        </div>
                                    </div>


                                    {renderKeywordMetrics(currentArticle.id)}

                                    <div className="flex items-center justify-center space-x-4 mt-4">
                                        {processingTasks[currentArticle.id] ? (
                                            <div className="flex items-center gap-2">
                                                <FaSpinner className="animate-spin text-white" />
                                                {processingTasks[currentArticle.id].message}
                                            </div>
                                        ) : currentArticle.status === 0 ? (
                                            <>
                                                <div className="relative group">
                                                    <button
                                                        className="p-2 rounded hover:bg-gray-600 transition-all"
                                                        onClick={() => handleAcceptReject(currentArticle.id, 'accept')}
                                                    >
                                                        <FaThumbsUp className="text-green-500 hover:text-green-400" />
                                                    </button>
                                                    <span className="absolute bottom-[-1.5rem] left-1/2 transform -translate-x-1/2 text-xs text-green-400 bg-gray-700 px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                                                        Accept
                                                    </span>
                                                </div>
                                                <div className="relative group">
                                                    <button
                                                        className="p-2 rounded hover:bg-gray-600 transition-all"
                                                        onClick={() => handleOpenFeedbackModal(currentArticle.id)}
                                                    >
                                                        <FaThumbsDown className="text-red-500 hover:text-red-400" />
                                                    </button>
                                                    <span className="absolute bottom-[-1.5rem] left-1/2 transform -translate-x-1/2 text-xs text-red-400 bg-gray-700 px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                                                        Reject
                                                    </span>
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <div className="relative group">
                                                    <button
                                                        className="p-2 rounded hover:bg-gray-600 transition-all"
                                                        onClick={() => navigate(`/article/${currentArticle.id}`)}
                                                    >
                                                        <FaEdit className="text-blue-500 hover:text-blue-400" />
                                                    </button>
                                                    <span className="absolute bottom-[-1.5rem] left-1/2 transform -translate-x-1/2 text-xs text-blue-400 bg-gray-700 px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                                                        Edit
                                                    </span>
                                                </div>
                                                <div className="relative group">
                                                    <button
                                                        className="p-2 rounded hover:bg-gray-600 transition-all"
                                                        onClick={() => handleDownloadArticle(currentArticle)}
                                                    >
                                                        <FaDownload className="text-green-500 hover:text-green-400" />
                                                    </button>
                                                    <span className="absolute bottom-[-1.5rem] left-1/2 transform -translate-x-1/2 text-xs text-green-400 bg-gray-700 px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                                                        Download
                                                    </span>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    ) : (
                        <p>No articles available.</p>
                    )}
                    {filteredArticles.length > 1 && (
                        <div className="flex justify-center w-full max-w-md mt-4">
                            {filteredArticles.map((_, index) => (
                                <button
                                    key={index}
                                    onClick={() => setCurrentArticleIndex(index)}
                                    className={`h-2 w-2 mx-1 rounded-full transition-colors duration-300 ${currentArticleIndex === index ? 'bg-white' : 'bg-gray-500'}`}
                                    aria-label={`Go to article ${index + 1}`}
                                ></button>
                            ))}
                        </div>
                    )}
                </div>
            ) : (
                //Web View of the table
                <div className="overflow-x-auto relative shadow-md sm:rounded-lg">
                    <div className="flex items-center gap-4 mb-6">
                        <select
                            className="px-4 py-2 border border-gray-700 rounded-lg bg-gray-800 text-white focus:outline-none focus:ring-1 focus:ring-gray-600 focus:border-gray-600 transition-all"
                            value={selectedStatus}
                            onChange={(e) => setSelectedStatus(e.target.value)}
                        >
                            <option value="">All Statuses</option>
                            <option value="0">Incomplete</option>
                            <option value="1">Progress</option>
                            <option value="2">Done</option>
                        </select>

                        <select
                            className="px-4 py-2 border border-gray-700 rounded-lg bg-gray-800 text-white focus:outline-none focus:ring-1 focus:ring-gray-600 focus:border-gray-600 transition-all"
                            value={selectedType}
                            onChange={(e) => setSelectedType(e.target.value)}
                        >
                            <option value="">All Types</option>
                            {Array.from(new Set(sortedArticles.map((article) => article.type.trim()))).map((type) => (
                                <option key={type} value={type}>
                                    {type}
                                </option>
                            ))}
                        </select>
                        <div className="relative w-full flex">
                        <DatePicker
                          selectsRange
                          startDate={startDate}
                          endDate={endDate}
                          onChange={handleDateChange}
                          isClearable={true}
                          placeholderText="Select Date Range"
                          className="w-60 px-4 py-2 border border-gray-700 rounded-lg bg-gray-800 text-white focus:outline-none focus:ring-1 focus:ring-gray-600 focus:border-gray-600 transition-all"
                          // Add this custom style prop to target the clear button
                          style={{
                            position: 'relative', // Ensure relative positioning for the container
                          }}
                        />
                      </div>
                    </div>

                <div className="overflow-x-auto relative shadow-md sm:rounded-lg min-h-[300px]">
                {filteredArticles.length > 0 ?
                <table className="w-full text-sm text-left text-gray-400">
                    <thead className="text-xs uppercase bg-gray-700 text-gray-400">
                    <tr>
                    <th
                        id="column-title"
                        scope="col"
                        className="px-6 py-3 cursor-pointer hover:bg-gray-600 normal-case"  // Added normal-case
                        onClick={() => requestSort('title')}
                    >
                        <div className="flex items-center">
                            Title
                            <span className="ml-1">{getSortIcon('title')}</span>
                        </div>
                        <Tooltip
                            id="title-tooltip"
                            place="top"
                            effect="solid"
                            className="bg-slate-800 text-white px-3 py-2 rounded-md text-sm max-w-[300px]"
                        >
                            The title of the article. Underneath is the pitch of what the article will cover.
                        </Tooltip>
                    </th>
                    <th
                        id="column-status"
                        scope="col"
                        className="px-6 py-3 cursor-pointer hover:bg-gray-600 normal-case"  // Added normal-case
                        onClick={() => requestSort('status')}
                    >
                        <div className="flex items-center">
                            Status
                            <span className="ml-1">{getSortIcon('status')}</span>
                            <span data-tooltip-id="status-tooltip" className="ml-1 cursor-pointer">
                                <FaInfoCircle className="text-gray-400 hover:text-gray-300" size={14} />
                            </span>
                        </div>
                        <Tooltip
                            id="status-tooltip"
                            place="top"
                            effect="solid"
                            className="bg-slate-800 text-white px-3 py-2 rounded-md text-sm max-w-[300px]"
                        >
                            The current status of the article. It's either Incomplete, Progress, or Done.
                        </Tooltip>
                    </th>
                    <th
                        id="column-date"
                        scope="col"
                        className="px-6 py-3 cursor-pointer hover:bg-gray-600 normal-case"  // Added normal-case
                        onClick={() => requestSort('date')}
                    >
                        <div className="flex items-center">
                            Date
                            <span className="ml-1">{getSortIcon('date')}</span>
                            <span data-tooltip-id="date-tooltip" className="ml-1 cursor-pointer">
                                <FaInfoCircle className="text-gray-400 hover:text-gray-300" size={14} />
                            </span>
                        </div>
                        <Tooltip
                            id="date-tooltip"
                            place="top"
                            effect="solid"
                            className="bg-slate-800 text-white px-3 py-2 rounded-md text-sm max-w-[300px]"
                        >
                            The date the article will be completed and published.
                        </Tooltip>
                    </th>
                    <th
                        id="column-type"
                        scope="col"
                        className="px-6 py-3 cursor-pointer hover:bg-gray-600 normal-case"  // Added normal-case
                        onClick={() => requestSort('type')}
                    >
                        <div className="flex items-center">
                            Type
                            <span className="ml-1">{getSortIcon('type')}</span>
                            <span data-tooltip-id="type-tooltip" className="ml-1 cursor-pointer">
                                <FaInfoCircle className="text-gray-400 hover:text-gray-300" size={14} />
                            </span>
                        </div>
                        <Tooltip
                            id="type-tooltip"
                            place="top"
                            effect="solid"
                            className="bg-slate-800 text-white px-3 py-2 rounded-md text-sm max-w-[300px]"
                        >
                            The type of the article (e.g., Opinion, How-to, Versus etc.).
                        </Tooltip>
                    </th>

                        <th
                            id="column-actions"
                            scope="col"
                            className="px-6 py-3"
                        >
                            Actions
                        </th>
                        </tr>

                    </thead>
                          {isWelcomeModalOpen && (
                            <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex justify-center items-center z-50">
                                <div className="bg-gray-700 rounded-lg p-6 w-full max-w-md text-white shadow-lg relative"> {/* Make container relative */}
                                    <div className="absolute top-2 right-2 cursor-pointer" onClick={closeWelcomeModal}>
                                        <FaTimes className="text-gray-400 hover:text-gray-300" />
                                    </div>
                                    <h2 className="text-2xl font-bold mb-4">{welcomeModalPages[currentPage].title}</h2>
                                    {welcomeModalPages[currentPage].content}


                                    <div className="flex justify-between mt-6">
                                        <button
                                            onClick={prevPage}
                                            disabled={currentPage === 0}
                                            className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600 disabled:opacity-50"
                                        >
                                            Back
                                        </button>
                                        {currentPage < welcomeModalPages.length - 1 ? (
                                            <button
                                                onClick={nextPage}
                                                className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                                            >
                                                Next
                                            </button>
                                        ) : (
                                            <button
                                                onClick={closeWelcomeModal}
                                                className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
                                            >
                                                Got it! Let's go! ✅
                                            </button>
                                        )}
                                    </div>
                                    <div className="text-center mt-2 text-gray-400">Page {currentPage + 1} of {welcomeModalPages.length}</div>
                                </div>
                            </div>
                        )}
                    <tbody>
                        {filteredArticles.map((article) => (
                            <tr key={article.id} className="border-b bg-gray-800 border-gray-700 hover:bg-gray-600">
                                <td className="px-6 py-4 font-medium text-white max-w-xs">
                                    <div className="w-full flex flex-col">
                                    <div
                                      className={`md:max-w-full ${article.status === 0 ? 'cursor-not-allowed' : 'cursor-pointer hover:underline'}`}
                                      title={article.title} // Shows full title on hover
                                      onClick={() => {
                                        if (article.status !== 0) {
                                            handleTitleClick(article.id);
                                        }
                                    }}
                                    >
                                      {article.title}
                                    </div>

                                    <div className={`mt-2 ${article.status === 0 ? 'text-gray-500' : 'text-gray-400/80'}`}>
                    {/* Only show the truncated text when not expanded */}
                    {expandedArticle !== article.id && (
                        <div className="line-clamp-2">
                            {article.pitch}
                        </div>
                    )}

                    {/* Show full text when expanded */}
                    {expandedArticle === article.id && (
                        <div className="text-sm text-gray-400/80">
                            {article.pitch}
                        </div>
                    )}

                    {/* Show the Show More button only when truncated */}
                    {article.pitch.length > 100 && expandedArticle !== article.id && (
                        <button
                            onClick={() => setExpandedArticle(article.id)}
                            className="mt-1 text-blue-500 hover:text-blue-400 text-sm flex items-center"
                        >
                            <span>Show More</span>
                            <svg
                                className="transform transition-transform duration-200"
                                width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M6 8L3 5H9L6 8Z" fill="currentColor" />
                            </svg>
                        </button>
                    )}

                    {/* Show the Show Less button when expanded */}
                    {expandedArticle === article.id && (
                        <button
                            onClick={() => setExpandedArticle(null)}
                            className="mt-1 text-blue-500 hover:text-blue-400 text-sm flex items-center gap-2"
                        >
                            <span>Show Less</span>
                            <svg
                                className="transform transition-transform duration-200 rotate-180"
                                width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M6 8L3 5H9L6 8Z" fill="currentColor" />
                            </svg>
                        </button>
                    )}
                </div>




                                            <div
                                                className="text-xs text-gray-400/80 leading-relaxed break-words transition-colors mt-2 cursor-pointer group-hover:text-gray-300/90"
                                                data-tooltip-id={`keyword-tooltip-${article.id}`}
                                            >
                                                {(() => {
                                                    const { totalSearchVolume, avgDifficulty, competitionLevels, avgCpc } =
                                                        calculateAggregatedMetrics(article.id);
                                                    return (
                                                        <div className="flex items-center gap-2 text-gray-400">
                                                        <button
                                                            className="flex items-center gap-1 text-blue-500 hover:text-blue-400 focus:outline-none"
                                                            onClick={() => renderKeywordMetrics(article.id)}  // Trigger keyword metrics when clicked
                                                        >
                                                            <FaChartLine className="w-4 h-4" />
                                                            <span className="text-sm">View Keyword Metrics</span>
                                                        </button>
                                                    </div>


                                                    );
                                                })()}
                                                <Tooltip
                                                    id={`keyword-tooltip-${article.id}`}
                                                    className="bg-gray-700/95"
                                                    content={renderKeywordTooltip(article.id)}
                                                />
                                            </div>
                                        </div>
                                    </td>
                                    <td className="px-6 py-4">
                                      <span
                                        className={`inline-flex items-center justify-center w-24 px-3 py-1 rounded-full font-bold text-xs sm:text-sm
                                        ${
                                          article.status === 1 ? "bg-amber-500/20 text-amber-500"
                                          : article.status === 2 ? "bg-green-500/20 text-green-500"
                                          : article.status === 0 ? "bg-red-400/20 text-red-400"
                                          : "bg-gray-500/20 text-gray-500"
                                        }`}
                                      >
                                        {article.status === 1 ? "Progress"
                                          : article.status === 2 ? "Done"
                                          : article.status === 0 ? "Incomplete"
                                          : "Unknown"}
                                      </span>
                                    </td>


                                    <td className="px-6 py-4">{new Date(article.date).toLocaleDateString()}</td>

                                    <td className="px-6 py-4">{article.type}</td>

                                    <td className="px-6 py-4">
                                        {processingTasks[article.id] ? (
                                            <div className="flex items-center gap-2">
                                                <FaSpinner className="animate-spin text-white" />
                                                {processingTasks[article.id].message}
                                            </div>
                                        ) : article.status === 0 ? (
                                            <div className="flex items-center justify-center gap-4">
                                                <div className="relative group">
                                                <button
                                                        onClick={() => handleAcceptReject(article.id, 'accept')}
                                                        className="relative flex items-center gap-2 px-3 py-2 rounded-lg
                                                      bg-green-500/10 text-green-500 hover:bg-green-500/20
                                                      transition-colors duration-200"
                                                  >
                                                    <FaThumbsUp className="w-4 h-4" />
                                                    <span className="text-sm font-medium hidden sm:inline">Approve</span>


                                                </button>
                                                </div>
                                                <div className="relative group">
                                                <button
                                                        onClick={() => handleOpenFeedbackModal(article.id)}
                                                        className="relative flex items-center gap-2 px-3 py-2 rounded-lg
                                                      bg-red-500/10 text-red-500 hover:bg-red-500/20
                                                      transition-colors duration-200"
                                                  >
                                                    <FaThumbsDown className="w-4 h-4" />
                                                    <span className="text-sm font-medium hidden sm:inline">Reject</span>

                                                  </button>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="flex items-center justify-center gap-4">
                                                <div className="relative group">
                                                <button
                                                  onClick={() => navigate(`/article/${article.id}`)}
                                                  className="relative flex items-center gap-2 px-3 py-2 rounded-lg
                                                            bg-blue-500/10 text-blue-500 hover:bg-blue-500/20
                                                            transition-colors duration-200"
                                                >
                                                  <FaEdit className="w-4 h-4" />
                                                  <span className="text-sm font-medium hidden sm:inline">Edit</span>
                                                </button>
                                                                                                </div>
                                                                                                <div className="relative group">
                                                                                                <button
                                                  onClick={() => handleDownloadArticle(article)}
                                                  className="relative flex items-center gap-2 px-3 py-2 rounded-lg
                                                            bg-teal-500/10 text-teal-500 hover:bg-teal-500/20
                                                            transition-colors duration-200"
                                                >
                                                  <FaDownload className="w-4 h-4" />
                                                  <span className="text-sm font-medium hidden sm:inline">Download</span>
                                                </button>
                                                </div>
                                            </div>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>

                    </table>
                    :
<div className="min-h-[300px] flex flex-col items-center justify-center  rounded-lg p-8">
  {/* An icon to visually represent no data */}
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-16 h-16 text-gray-400 mb-4"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 17v-5a3 3 0 016 0v5m-6 4h6a2 2 0 002-2v-1a2 2 0 00-2-2h-6a2 2 0 00-2 2v1a2 2 0 002 2z" />
  </svg>
  {/* Main text */}
  <p className="text-gray-600 text-lg font-medium">No articles available</p>
  {/* Subtext */}
  <p className="text-gray-500 mt-2">Try adjusting your filters or check back later.</p>
</div>

                    }
                    </div>
                </div>
            )}

{showFeedbackModal && (
  <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex justify-center items-center">
    <div className="bg-gray-700 p-6 rounded-md shadow-lg w-[520px]"> {/* Increased width here */}
      <h2 className="text-xl font-bold mb-6 text-white text-center">Provide Feedback</h2>

      {/* Predefined feedback buttons */}
      <div className="flex gap-4 mb-6 justify-center intems-center">
        <button
          className="flex items-center justify-center px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 text-sm"
          onClick={() => handlePredefinedFeedback("The pitch doesn't align with our current needs.")}
        >
          <FiXCircle className="mr-2" /> Misalignment
        </button>
        <button
          className="flex items-center justify-center px-6 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 text-sm"
          onClick={() => handlePredefinedFeedback("The pitch lacks sufficient detail or context.")}
        >
          <FiFileText className="mr-2" /> Detail
        </button>
        <button
          className="flex items-center justify-center px-6 py-2 bg-yellow-500 text-white rounded-lg hover:bg-yellow-600 text-sm"
          onClick={() => handlePredefinedFeedback("The pitch is not relevant to our audience.")}
        >
          <FiSlash className="mr-2" /> Relevance
        </button>
      </div>

      {/* Textarea for manual feedback */}
      <textarea
        className="w-full p-3 mb-6 rounded-lg text-black bg-white placeholder-gray-500 focus:outline-none"
        rows="4"
        placeholder="Enter your feedback here..."
        value={feedbackText}
        onChange={handleFeedbackChange}
      />

      <div className="flex justify-between">
        <button
          className="px-6 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600"
          onClick={handleCloseFeedbackModal}
        >
          Cancel
        </button>
        <button
          className="px-6 py-2 bg-rose-500 text-white rounded-lg hover:bg-rose-600"
          onClick={handleRejectWithFeedback}
        >
          Submit Feedback
        </button>
      </div>
    </div>
  </div>
)}


             {showSubscriptionExpiredModal && (
                <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex justify-center items-center z-50">
                    <div className="bg-gray-700 rounded-lg p-6 w-full max-w-md text-white shadow-lg relative"> {/* Make container relative */}
                        <div className="absolute top-2 right-2 cursor-pointer" onClick={() => setShowSubscriptionExpiredModal(false)}>
                            <FaTimes className="text-gray-400 hover:text-gray-300" />
                        </div>
                        <h2 className="text-2xl font-bold mb-4">Subscription Expired</h2>
                        <p className="mb-4">
                            Your Trendhopper subscription has expired. As a result, we have stopped producing new blog posts for you. To continue receiving fresh content, please renew your subscription.
                        </p>
                        <div className="flex justify-center">
                            <button
                                onClick={handleUpgradeClick}
                                className="px-6 py-3 bg-gradient-to-r from-purple-400 via-purple-500 to-purple-600 hover:bg-gradient-to-br text-white font-semibold rounded-md"
                            >
                                Renew Subscription
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ArticleListView;
